/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { TextField, Radio } from '@insticator/insticator-ui'
import Space from 'material/space/space'
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg'
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { ReactComponent as EmojiAdd } from 'assets/icons/emoji-add.svg'
import { ReactComponent as ImageAdd } from 'assets/icons/image.svg'
import { ReactComponent as GifAdd } from 'assets/icons/gif.svg'
import { ReactComponent as VideoAdd } from 'assets/icons/video.svg'
import { ReactComponent as TextFormat } from 'assets/icons/text-format.svg'
// content
import PreviewConfig from '../../previewconfig/previewconfig';
// styles
import injectSheet from 'react-jss'
import styles from './placeholdertext_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : LOAD BEHIND BUTTON ~~~~~~~~~~ ========== */
const PlaceholderText = injectSheet(styles)((props) => {

  const { inputFieldPlaceholderType, noCommentPlaceholder, beforeFirstCommentPlaceholder, afterFirstCommentPlaceholder, onChange } = props

  return (
    <SectionGroupV2 
      klass={`placeholdertext ${props.classes.placeholdertext}`}
      title={'Placeholder Text'} 
      description={'Define the placeholder text of the comment input field.'} 
      indented
    >
      <Space gap={16} direction={'column'}>
        <Space direction={'column'}>
            <span>Choose a format</span>
            <Radio 
              isList
              title={`Default`}
              checked={inputFieldPlaceholderType === 'DEFAULT'}
              handleChange={() => {
                onChange('inputFieldPlaceholderType', 'DEFAULT', {
                  noCommentPlaceholder: 'Start the conversation...',
                  beforeFirstCommentPlaceholder: 'Join the conversation...',
                  afterFirstCommentPlaceholder: 'Post again'
                })
              }}
            />
            <Radio 
              isList
              title={`Custom`}
              checked={inputFieldPlaceholderType === 'CUSTOM'}
              handleChange={() => onChange('inputFieldPlaceholderType', 'CUSTOM')}
            />
        </Space>
        <TextField 
          type={`text`} 
          name={`nocommentplaceholer`} 
          icon={<ComposeIcon />}
          label={'When there are no comments yet'}
          value={noCommentPlaceholder} 
          handleChange={e => onChange('noCommentPlaceholder', e.target.value)}
          placeholder={``} 
          disabled={inputFieldPlaceholderType === 'DEFAULT'}
        />
        <TextField
          type={'text'}
          name={'beforeFirstCommentPlaceholder'}
          icon={<ComposeIcon />}
          label={'When there are comments but a user hasn’t left one yet'}
          value={beforeFirstCommentPlaceholder}
          handleChange={e => onChange('beforeFirstCommentPlaceholder', e.target.value)}
          placeholder={''}
          disabled={inputFieldPlaceholderType === 'DEFAULT'}
        />
        <TextField 
          type={`text`} 
          name={`afterFirstCommentPlaceholder`} 
          icon={<ComposeIcon />}
          label={'After a user has left a comment'}
          value={afterFirstCommentPlaceholder} 
          handleChange={e => onChange('afterFirstCommentPlaceholder', e.target.value)}
          placeholder={``} 
          disabled={inputFieldPlaceholderType === 'DEFAULT'}
        />
      </Space>
      <PreviewConfig>
        <Space klass={'commentbox'} alignItems={'flex-start'} direction={'column'}>
          <div className={'commenttextarea'}>
            <h1>{beforeFirstCommentPlaceholder}</h1>
          </div>
          <Space alignItems={'center'} justifiyContent={'space-between'}>
            <Space klass={'commentrichmedia'} alignItems={'center'}>
              <EmojiAdd />
              <ImageAdd />
              <GifAdd />
              <VideoAdd />
              <TextFormat />
            </Space>
            <div className='postbutton button'>Post</div>
          </Space>
        </Space>
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PlaceholderText